<template>
  <NavigationLayout navigationTitle="年間報酬額">
    <div id="total_transfer__wrapper" slot="contents">
      <div id="total_transfer__container">
        <section id="total_transfer__header" v-if="!hasTotalTransferHistories">
          <p>年間報酬額の履歴はありません</p>
        </section>
        <section
          v-for="(t, index) in totalTransfers"
          :key="`total_transfer_${index}`"
        >
          <ListSubheader v-bind:title="t.label" />
          <ListItem
            title="報酬額"
            v-bind:actionText="formatDepositValue(t.amount)"
          />
          <ListItem
            title="源泉徴収税額"
            v-bind:actionText="formatDepositValue(t.tax)"
          />
          <ListItem
            title="支払金額"
            v-bind:actionText="formatDepositValue(t.credit)"
          />
        </section>
        <div>
          <div v-bind:style="CautionsStyle">
            <p>
              ※年間報酬額の集計は毎月3日までに行われ、集計した月の前月分までが反映されます。
            </p>
            <p>
              例：1月1日〜7月31日までの報酬額は8月3日までに集計を行い、年間報酬額ページに反映されます。
            </p>
          </div>
        </div>
      </div>
    </div>
  </NavigationLayout>
</template>
<script>
import API from '@/utils/API'
import NavigationLayout from '@/components/NavigationLayout'
import ListItem from '@/components/ListItem'
import ListSubheader from '@/components/ListSubheader'
import MypageStyle from '@/styles/mypage'
import { bankAccountTypeForValue } from '@/utils/MasterBank'
import formatter from '@/utils/Formatter'
export default {
  name: 'total_transfer',
  components: {
    NavigationLayout,
    ListItem,
    ListSubheader,
  },
  data: function () {
    return {
      totalTransfers: [],
      CautionsStyle: MypageStyle.Cautions,
      ListItemStyleSectionLast: MypageStyle.ListItemSectionLast,
    }
  },
  computed: {
    hasTotalTransferHistories: function () {
      return this.totalTransfers.length > 0
    },
  },
  methods: {
    fetchTotalTransferHistories: async function () {
      const request = API.Request.liveCoinTotalTransferHistoriesList()
      const response = await API.load(request)
      if (response.Histories) {
        this.totalTransfers = response.Histories
      }
    },
    formatDepositValue: function (value) {
      return '￥' + formatter.numberWithCommas(value)
    },
  },
  mounted() {
    this.fetchTotalTransferHistories()
  },
}
</script>

<style scoped>
#total_transfer__wrapper {
  position: relative;
  height: auto;
  min-height: 100%;
  background-color: #fafafa;
}

#total_transfer__container {
  font-family: sans-serif;
  font-size: 14px;
  line-height: 1.43;
  color: #262626;
  padding-top: 20px;
  padding-bottom: 49px;
}

#total_transfer__header {
  padding: 12px 15px;
  text-align: left;
  background-color: #ffffff;
  line-height: 1.5;
  color: #383838;
}
section {
  margin-bottom: 20px;
}
.total_transfer__deposit_to {
  line-height: 1.5;
  text-align: right;
}
</style>
